import { useState } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';

export const PreviewPinterest = ({ post, isLoading }) => {
    const { t } = useTranslation();
    const [failedImageSrc, setFailedImageSrc] = useState(null);
    const imageSrc = post?.medias?.[0]?.image;

    if (isLoading) {
        return (
            <span
                data-testid="loading"
                className="square block animate-pulse rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack"
            />
        );
    }

    // ponytail: match IG/FB/LI/X — no medias → empty; missing/broken image → media_not_loaded
    if (!post?.medias?.length) {
        return null;
    }

    if (!imageSrc || failedImageSrc === imageSrc) {
        return (
            <div
                className="relative flex w-full flex-col items-center overflow-hidden rounded-md bg-icoGray-100 p-4 dark:bg-icoDarkMode-deepBlack lg:p-10"
                aria-label="preview-pinterest">
                <div className="flex min-h-[200px] w-full flex-col items-center justify-center space-y-3 text-icoGray-500 dark:text-icoDarkMode-wolf">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-icoGray-300 dark:bg-icoDarkMode-anthracite">
                        <Icon icon="content" />
                    </span>
                    <p className="text-sm">{t('commons:media_not_loaded')}</p>
                </div>
            </div>
        );
    }

    return (
        <div
            className="relative flex w-full flex-col items-center overflow-hidden rounded-md bg-icoGray-100 p-4 dark:bg-icoDarkMode-deepBlack lg:p-10"
            aria-label="preview-pinterest">
            <div className="relative pb-[100px]">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    src={imageSrc}
                    className="z-0 w-full rounded-[36px]"
                    alt={post?.title}
                    onError={() => setFailedImageSrc(imageSrc)}
                />
                <iframe
                    title="preview-pinterest"
                    src={`https://assets.pinterest.com/ext/embed.html?id=${post?.id}`}
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    className="absolute left-0 top-0 z-2"
                />
            </div>
        </div>
    );
};
